module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Accolade","short_name":"Accolade","start_url":"/","background_color":"#00aeef","theme_color":"#00aeef","theme_color_in_head":false,"display":"minimal-ui","icon":"images/accolade_favicon.png","legacy":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"89dc54906a63bbbf3c2ecba521d40eab"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
